// extracted by mini-css-extract-plugin
module.exports =  {"sidebar":"zZuFtlP","fade":"jTigRbM"};